// extracted by mini-css-extract-plugin
module.exports = {"productFlag":"sale-flag_productFlag__baQRH","sale":"sale-flag_sale__4Qony"};